import { ValidarEmailHelper } from "../../../helpers";
const validarEmailHelper = new ValidarEmailHelper();

export class BancoCaixa {
  nome = null;
  tipoConta = null;
  dataSaldoInicial = null;
  saldoInicial = null;
  bancoId = null;
  agencia = null;
  digitoAgencia = null;
  aberturaAutomatica = false;
  conta = null;
  digitoConta = null;
  codigoBeneficiario = null;
  contato = null;
  diasCarencia = null;
  chavePix = null;
  nomeGerente = null;
  telefoneGerente = null;
  emailGerente = null;
  ativado = true;
  caixaBanco = false;
  responsaveisList = [];

  constructor(dadosBancoCaixa, id) {
    this.nome = dadosBancoCaixa.nome;
    this.tipoConta = dadosBancoCaixa.tipoConta;
    this.dataSaldoInicial = dadosBancoCaixa.dataSaldoInicial;
    this.saldoInicial = dadosBancoCaixa.saldoInicial;
    this.aberturaAutomatica = dadosBancoCaixa.aberturaAutomatica || false;
    this.chavePix = dadosBancoCaixa.chavePix;
    this.nomeGerente = dadosBancoCaixa.nomeGerente;
    this.telefoneGerente = dadosBancoCaixa.telefoneGerente;
    this.emailGerente = dadosBancoCaixa.emailGerente;
    this.ativado = dadosBancoCaixa.ativado;
    this.responsaveisList = dadosBancoCaixa.responsaveisList;
    this.caixaBanco = dadosBancoCaixa.caixaBanco ?? false;
    if (dadosBancoCaixa.caixaBanco || id) {
      this.bancoId = dadosBancoCaixa.bancoId;
      this.codigoBancario = dadosBancoCaixa.codigoBancario;
      this.agencia = dadosBancoCaixa.agencia;
      this.digitoAgencia = dadosBancoCaixa.digitoAgencia;
      this.conta = dadosBancoCaixa.conta;
      this.digitoConta = dadosBancoCaixa.digitoConta;
      this.codigoBeneficiario = dadosBancoCaixa.codigoBeneficiario;
      this.contato = dadosBancoCaixa.contato;
      this.diasCarencia = dadosBancoCaixa.diasCarencia;
      this.endereco = this.createEndereco(dadosBancoCaixa.endereco);
    }
  }

  createEndereco(endereco) {
    return {
      id: endereco.id,
      cep: endereco.cep,
      logradouro: endereco.logradouro,
      numero: endereco.numero,
      bairro: endereco.bairro,
      cidadeId: endereco.cidadeId
    }
  }

  validarEmail() {
    return validarEmailHelper.email(this.emailGerente);
  }
}
